import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../styles/SignUp.css";
import loginImg from "../../assets/loginImage.jpeg";
import Loader from "../../components/common/Loading";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import logo from "../../assets/Logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { EMAIL_REGEX } from "../../constants/common";
import axios from "axios";
import PlacesAutocomplete from "../../components/provider/GoogleAutoComplete";
import { useLoadScript } from "@react-google-maps/api";

function ProviderSignUp() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    password: "",
    confirmPassword: "",
    termsAndConditions: false,
    address: "",
    providerType: "",
    licenseNo: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [streetAddress, setStreetAddress] = useState(
    {
      street: "",
      city: "",
      state: "",
      pin: "",
    } || null
  );
  //console.logstreetAddress?.street, 'streetAddress')
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (streetAddress !== null) {
      setFormData(prevForm => ({
        ...prevForm,
        address: streetAddress?.street
      }));
    }
  }, [streetAddress]);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyCmYRzM9CMuVD0C0xkQP6Vt9VyVcfMKQ2o",
    libraries: ["places"],
  });


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value; // Remove trim for spaces
    setFormData({
      ...formData,
      [name]: newValue,
    });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const togglePasswordConfirmVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSubmitted(true);

    if (formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }
    if (!EMAIL_REGEX.test(formData.email)) {
      toast.error("Invalid email address");
      return;
    }
    const mobileRegex = /^[0-9]{8,15}$/;
    if (!mobileRegex.test(formData.mobile)) {
      toast.error("Invalid mobile number");
      return;
    }
    const nameRegex = /^[A-Za-z ]+$/;
    if (!nameRegex.test(formData.firstName) || !nameRegex.test(formData.lastName)) {
      toast.error("First Name and Last Name should only contain alphabets and spaces");
      return;
    }

    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
    if (!passwordRegex.test(formData.password)) {
      toast.error("Password must be at least 8 characters long and contain both letters and numbers");
      return;
    }
    if (!formData.termsAndConditions) {
      toast.error("Please accept the terms and conditions");
      return;
    }

    try {
      const resIsEmailExist = await axios.get(
        `https://yelospace.com/api/is-exist/provider/${formData.email}`
      );
      if (resIsEmailExist.data.status === 200) {
        toast.error("Email already exists.");
        return;
      }

      const resIsProviderEmailExist = await axios.get(
        `https://yelospace.com/api/is-exist/user/${formData.email}`
      );
      if (resIsProviderEmailExist.data.status === 200) {
        toast.error("Email already exists for user.");
        return;
      }

      const IsMobileExist = await axios.get(
        `https://yelospace.com/api/is-exist/provider/${formData.mobile}`
      );

      if (IsMobileExist.data.status === 200) {
        toast.error("Mobile Number Already Exists.");
        return;
      }
      setLoading(true);
      const { confirmPassword, termsAndConditions, ...postData } = formData;

      const response = await fetch(
        "https://yelospace.com/api/send-otp/{email}",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(postData),
        }
      );

      if (response.status === 200) {
        localStorage.setItem("formdata", JSON.stringify(postData));
        navigate("/provider-verify-email");
      } else {
        toast.error("Failed to sign up");
      }
    } catch (error) {
      console.error("Error occurred:", error);
      toast.error("An error occurred during sign up");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      {loading ? (
        <Loader className="d-flex justify-content-center align-items-center" />
      ) : (
        <div className="signup-container">
          <div className="left-panel">
            <img src={loginImg} alt="Left Panel Image" />
          </div>
          <div className="right">
          <div className="w-100 d-flex justify-content-center">
              <Link to="/">
                <img src={logo} className="logo-img" alt="Left Panel Image" />
              </Link>
            </div>
            <h3 className="ml-4">Sign Up as Provider</h3>
            <form onSubmit={handleSubmit}>
              <div className="input-group-custums">
                <input
                  type="text"
                  id="firstname"
                  name="firstName"
                  placeholder="First Name *"
                  value={formData.firstName}
                  onChange={handleChange}
                />
                {submitted && !formData.firstName && (
                  <span className="error-signup">First Name is required</span>
                )}
              </div>
              <div className="input-group-custums">
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  placeholder="Last Name *"
                  value={formData.lastName}
                  onChange={handleChange}
                />
                {submitted && !formData.lastName && (
                  <span className="error-signup">Last Name is required</span>
                )}
              </div>
              <div className="input-group-custums">
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Email *"
                  value={formData.email}
                  onChange={handleChange}
                />
                {submitted && !formData.email && (
                  <span className="error-signup">Email is required</span>
                )}
              </div>
              <div className="input-group-custums">
                <input
                  type="tel"
                  id="mobile"
                  name="mobile"
                  placeholder="Mobile Number *"
                  value={formData.mobile}
                  onChange={handleChange}
                />
                {submitted && !formData.mobile && (
                  <span className="error-signup">Mobile Number is required</span>
                )}
              </div>
              <div className="input-group-custums">
              <PlacesAutocomplete
                  isLoaded={isLoaded}
                  setFormData={setStreetAddress}
                  setSelected={setSelected}
                />
                {submitted && !streetAddress?.street && (
                  <span className="error-signup">Address is required</span>
                )}
              </div>
              <div className="input-group-custums">
                <input
                  type="text"
                  id="licenseNo"
                  name="licenseNo"
                  placeholder="License No "
                  value={formData.licenseNo}
                  onChange={handleChange}
                />
              </div>
              <div className="input-group-custums">
                <select
                  className="select-input"
                  id="providerType"
                  name="providerType"
                  value={formData.providerType}
                  onChange={handleChange}
                  required
                >
                  <option value="">Provider Type *</option>
                  <option value="1">Brokerage</option>
                  <option value="2">Business</option>
                </select>
                {submitted && !formData.providerType && (
                  <span className="error-signup">Provider Type is required</span>
                )}
              </div>
              <div className="input-group-custums">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  placeholder="Password *"
                  value={formData.password}
                  onChange={handleChange}
                />
                <span className="password-toggle-btn" onClick={togglePasswordVisibility}>
                  {showPassword ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                </span>
                {submitted && !formData.password && (
                  <span className="error-signup">Password is required</span>
                )}
              </div>
              <div className="input-group-custums">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  id="confirmPassword"
                  name="confirmPassword"
                  placeholder="Confirm Password *"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                />
                <span className="password-toggle-btn" onClick={togglePasswordConfirmVisibility}>
                  {showConfirmPassword ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                </span>
                {submitted && !formData.confirmPassword && (
                  <p className="error-signup">Confirm Password is required</p>
                )}
              </div>
              <div className="checkbox-group-custum">
                <input
                  type="checkbox"
                  id="termsAndConditions"
                  name="termsAndConditions"
                  checked={formData.termsAndConditions}
                  onChange={handleChange}
                />
                <label htmlFor="termsAndConditions">
                  I accept the <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">terms and conditions</a> and <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">privacy policy</a>
                </label>
              </div>
              <div>
                {submitted && !formData.termsAndConditions && (
                  <p className="error-signup">Please accept the terms and conditions</p>
                )}
              </div>
              <div className="d-flex justify-content-center w-100 mt-2">
                <button type="submit" className="submit-btn">
                  Sign Up
                </button>
              </div>
              <div className="d-flex justify-content-center w-100 mt-4">
                <div className="continue">
                  <Link className="border py-3 px-3" style={{fontWeight:'bold'}} to="/">
                    Continue As Guest
                  </Link>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default ProviderSignUp;
